import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { DetailLinkWithEntityPeek } from "@/components/hub/DetailLinkWithEntityPeek";
import type { EntityPeekProps } from "@/components/hub/entityPeekTypes";
import { buildInsideSalesRepAgencyPath } from "@/components/inside-sales/RepAgencyDetailHoverHint";
import { cn } from "@/lib/utils";

const DETAIL_LINK_CLASS =
  "font-medium text-sky-700 hover:text-sky-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-1";

export function RepAgencyDetailLink({
  repAgencyId,
  repAgencyName,
  className,
  children,
  block = false,
}: {
  repAgencyId: number | null | undefined;
  repAgencyName?: string | null;
  className?: string;
  children?: ReactNode;
  block?: boolean;
}): ReactNode {
  const label =
    children ??
    (repAgencyName != null && repAgencyName.trim() !== "" ? repAgencyName.trim() : "—");
  if (repAgencyId == null || !Number.isFinite(repAgencyId) || repAgencyId <= 0) {
    return <span className={className}>{label}</span>;
  }

  const peekProps: EntityPeekProps = { kind: "rep_agency", repAgencyId };
  return (
    <DetailLinkWithEntityPeek
      block={block}
      peek={peekProps}
      trigger={
        <Link to={buildInsideSalesRepAgencyPath(repAgencyId)} className={cn(DETAIL_LINK_CLASS, className)}>
          {label}
        </Link>
      }
    />
  );
}
